import React, { useRef, useState, useEffect } from 'react';
import DataGrid, { Form, Column, Pager, Paging, FilterRow, Editing, Lookup, Toolbar, Item, DataGridRef, Button as GridButton } from 'devextreme-react/data-grid';
import Button from 'devextreme-react/button';
import { ordersDetailDataSource } from '../../datasources/ordersDetailDataSource';
import { dataGridErrorHandling } from '../../utils/errorHandling';
import PopupUpdateQtaOrder, { OrderQtaPopupHandle } from '../../components/popupUpdateQtaOrder/popupUpdateQtaOrder';
import PopupOrderProduct, { OrderProductPopupHandle } from '../../components/popupOrderProduct/popupOrderProduct';
import './ordertable.scss';
import { OrdiniApi } from '../../data';
import { apiConfiguration } from '../../apiConfig';
import { showError } from '../../utils/errorHandling';
import { useTranslation } from 'react-i18next';

type Props = {
    idOrdine: number,
    tipoOrdine: string,
    onChanged: () => void,
    readonly?: boolean
};

type state = {
    posdisponibile: string,
    posutilizzato: string,
    posrimanente: string
}

type statedatasource = {
    datasource: any
}

const OrderTable: React.FC<Props> = (params) => {
    const ordineqtaRef = useRef<OrderQtaPopupHandle>(null);
    const ordineproductRef = useRef<OrderProductPopupHandle>(null);
    const gridRef = useRef<DataGridRef>(null);
    const [state, setState] = useState<state>({ posdisponibile: "0", posutilizzato: "0", posrimanente: "0" });    
    const [statedatasource, setStateDatasource] = useState<statedatasource>({ datasource: null });
    const { t } = useTranslation();
    
    function dataGridInitNewRow(e: any) {
        // e.data.quantita = "12";
    }

    function new_click(e: any) {
        ordineproductRef.current?.new(params.idOrdine);
    }

    function edit_click(e: any) {
        ordineqtaRef.current?.edit(e.row.data.idOrdine, e.row.data.idDettaglio);
    }

    function refreshGrid() {
        gridRef.current?.instance().refresh();
    }

    function refreshGridUpd() {
        setStateDatasource({ datasource: ordersDetailDataSource(params.idOrdine)});
        params.onChanged();
        updatePos();
    }

    function removeGrid() {
        params.onChanged();
        updatePos();
    }

    function IsRecordModificabile(e: any) {
        return e.row.data.recordModificabile === true;
    }    

    function updatePos() {        
        const api = new OrdiniApi(apiConfiguration);
        api.getOrdinePos({ idOrdine: params.idOrdine })
            .then(function (data) {                
                if (data.length === 3) {
                    setState({
                        posdisponibile: String(data[0].valore),
                        posutilizzato: String(data[1].valore),
                        posrimanente: String(data[2].valore)
                    });
                }
                else {
                    setState({
                        posdisponibile: "0",
                        posutilizzato: "0",
                        posrimanente: "0"
                    });
                }              
            })
            .catch(showError);          
    }

    useEffect(() => {
        setStateDatasource({ datasource: ordersDetailDataSource(params.idOrdine)});
        updatePos();
    }, []);
    
    const textBoxOptionsPosDisponibile = {
        elementAttr: { id: 'textBoxOptionsPosDisponibile' },
        value: state.posdisponibile,
        readOnly: true,
        label: t('posdisponibile'),
        stylingMode: "outlined",
        labelMode: "static",
        focusStateEnabled: false
    }

    const textBoxOptionsPosUtlizzato = {
        elementAttr: { id: 'textBoxOptionsPosUtlizzato' },
        value: state.posutilizzato,
        readOnly: true,
        label: t('posutilizzato'),
        stylingMode: "outlined",
        labelMode: "static",
        focusStateEnabled: false
    }

    const textBoxOptionsPosRimanente = {
        elementAttr: { id: 'textBoxOptionsPosRimanente' },
        value: state.posrimanente,
        readOnly: true,
        label: t('posrimanente'),
        stylingMode: "outlined",
        labelMode: "static",
        focusStateEnabled: false
    }

    return (
        <React.Fragment>
            <DataGrid
                ref={gridRef}
                key="idDettaglio"
                className={'dx-card wide-card'}
                dataSource={statedatasource.datasource}
                showBorders={false}
                focusedRowEnabled={true}
                errorRowEnabled={false}
                defaultFocusedRowIndex={0}
                defaultSelectionFilter=""
                columnAutoWidth={true}
                columnHidingEnabled={true}
                onRowUpdating={function (e) {
                    e.newData = Object.assign({}, e.oldData, e.newData);
                }}
                onRowRemoved={removeGrid}
                onDataErrorOccurred={dataGridErrorHandling}
                onInitNewRow={dataGridInitNewRow}
            >

                <Editing
                    mode="popup"
                    allowUpdating={true}
                    allowAdding={true}
                    allowDeleting={true}>
                </Editing>

                <Paging defaultPageSize={10} />
                <Pager showPageSizeSelector={true} showInfo={true} />
                <FilterRow visible={true} />

                <Toolbar>
                    <Item
                        location="before"
                        widget="dxTextBox"
                        options={textBoxOptionsPosDisponibile}
                    />
                    <Item
                        location="before"
                        widget="dxTextBox"
                        options={textBoxOptionsPosUtlizzato}
                    />
                    <Item
                        location="before"
                        widget="dxTextBox"
                        options={textBoxOptionsPosRimanente}
                    />

                    <Item location="after">
                        <Button
                            icon='add'
                            onClick={new_click}
                            disabled={params.readonly}
                        />
                        <Button
                            icon='refresh'
                            onClick={refreshGrid}
                        />
                    </Item>
                </Toolbar>

                <Column type='buttons' >
                    <GridButton name="edit" onClick={edit_click} visible={IsRecordModificabile || !params.readonly} hint='Modifica Qta'/>
                    <GridButton name="delete" visible={IsRecordModificabile || !params.readonly} />
                </Column>

                <Column dataField={'idOrdine'} width={90} hidingPriority={1} allowEditing={false} visible={false} />
                <Column dataField={'idDettaglio'} width={90} hidingPriority={1} allowEditing={false} visible={false} />
                <Column dataField={'dataConsegna'} caption={t ('dataConsegna')} hidingPriority={6} />
                <Column dataField={'codiceProdotto'} caption={t ('codiceProdotto')} hidingPriority={6} />
                <Column dataField={'descrizioneProdotto'} caption={t ('descrizioneProdotto')} hidingPriority={4} />
                <Column dataField={'quantita'} caption={t ('quantita')} hidingPriority={3} />
                <Column dataField={'prezzo'} caption={t ('prezzo')} dataType='number' hidingPriority={2} />
                <Column dataField={'richiesta'} caption={t ('richiesta')} dataType='boolean' hidingPriority={1} visible={false}/>
                <Column dataField={'recordModificabile'} caption={t ('modificabile')} dataType='boolean' hidingPriority={1} visible={false} />
            </DataGrid>

            <PopupUpdateQtaOrder ref={ordineqtaRef} onChanged={refreshGridUpd} onInserted={refreshGridUpd} ></PopupUpdateQtaOrder>
            <PopupOrderProduct ref={ordineproductRef} onChanged={refreshGridUpd} ></PopupOrderProduct>

        </React.Fragment>
    );
};

export default OrderTable;